export default "__VITE_ASSET__DEJ54HZ3__"